/**
* Multi Content Card JS
* -----------------------------------------------------------------------------
*
* All the JS for the Multi Content Card component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'multi-content-card',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const mobileToggle = document.getElementById( 'mobile-dropdown-toggle' );
      const tabContainer = document.getElementById( 'tab-container' );
      const selectedTabTitle = document.getElementById( 'selected-tab-title' );

      // Mobile dropdown functionality
      if ( mobileToggle && tabContainer ) {
        mobileToggle.addEventListener( 'click', function() {
          if ( window.innerWidth < 1024 ) {
            $( tabContainer ).slideToggle();
          }
        } );

        tabContainer.querySelectorAll( 'button' ).forEach( ( button ) => {
          button.addEventListener( 'click', () => {
            selectedTabTitle.textContent = button.textContent.trim();
            if ( window.innerWidth < 1024 ) {
              $( tabContainer ).slideToggle();
            }
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'multi-content-card', COMPONENT );
} )( app );
